import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { ToastContainer } from '@myhealth-raccoon/components';

import { router } from './router';
import { SentryTagger } from 'src/components/SentryTagger';
import { MessageProvider } from 'src/contexts/message';
import { store } from 'src/store';

function App() {
    return (
        <MessageProvider>
            <Provider store={store}>
                <RouterProvider router={router} />
                <ToastContainer />
                <SentryTagger />
            </Provider>
        </MessageProvider>
    );
}

export default App;
